import InnerComponent from '@Components/Purchase/PurchaseIndent/PurchaseIndentList';
import orgContainer from '@Components/AppContainer';

const PurchaseIndentList = () => ((orgContainer(InnerComponent)));
export default PurchaseIndentList;